import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Observable } from "rxjs";
import { Action } from "@ngrx/store";
import * as GlobalActions from "./../actions/global.actions";
import { map, exhaustMap } from "rxjs/operators";

@Injectable()
export class GlobalEffects {
  constructor(
    private actions$: Actions,
    private http: HttpClient,
  ) {}
  //TODO: test createEffet mogration after angular 15 compilation fixes
  loadLeftPanelData$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(GlobalActions.GET_LEFT_PANEL_DATA),
      exhaustMap((action: GlobalActions.GetLeftPanelData) => {
        let ticker = action.payload.ticker
          ? `&ticker=${action.payload.ticker}`
          : "";
        if (action.payload.type === "comparable") {
          ticker = ``;
        }
        const industry = action.payload.industryName
          ? `&industryName=${encodeURIComponent(action.payload.industryName)}`
          : "";
        const bloombergTicker = action.payload.isBloombergTicker
          ? `&tickertype=b`
          : "";
        return this.http
          .get(
            `${window.apiUrl}/api/get_left_panel_data?type=${action.payload.type}${ticker}${industry}${bloombergTicker}`,
          )
          .pipe(
            map((leftPanel) => {
              const payload = {
                respData: leftPanel,
                key:
                  action.payload.type === "charts"
                    ? "charts"
                    : action.payload.ticker
                      ? action.payload.ticker
                      : action.payload.industryName
                        ? action.payload.industryName
                        : action.payload.watchlist,
                display: action.payload.display,
                // isCollapsed: action.payload.isCollapsed
              };
              return new GlobalActions.SetLeftPanelData(payload);
            }),
          );
      }),
    );
  });
}
